import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchGeblokkeerdeWekenForEntity } from '../services/fetchGeblokkeerdeWekenForEntity'

export { useGeblokkeerdeWekenForEntity, queryKey }

const queryKey = 'entity-geblokkeerde-weken'

const useGeblokkeerdeWekenForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchGeblokkeerdeWekenForEntity(entity),
    queryKey: [queryKey, entity],
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || [],
  }
}
